import '../Inscription.less';
import {Menu , Row, Col} from 'antd';
import {  HomeOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../Cabezal.jpg'
import {NavLink} from "react-router-dom";
import LangSelect from './LangSelect'


/** *
* *Menu used in all User Views
*/
class UserMenu extends Component {
  render() {  
    return (
        <div>
        <Row>
                <Col><NavLink to="/culturasOriginarias"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
              </Row>
                <Row justify="start" >
                <Col span={22}>
                  {!this.props.showOnlyLanguage && <Menu  mode="horizontal" style={{borderBottom:'none'}}>
                    <Menu.Item key="home" style={{borderBottom:'none'}} icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                      <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/culturasOriginarias"> Inicio</NavLink>
                    </Menu.Item>
                  </Menu>}
                </Col>
                <Col span={2}>
              <Menu mode="horizontal" style={{borderBottom:'none'}}>
              <LangSelect/>
              </Menu>
            </Col>
              </Row>
          </div>
    );
  }
}
export default UserMenu;


